const ApiAttributesKeys = {
  notesIdKey: 'id',
  notesNameKey: 'name',
  notesReadingIdKey: 'readingId',
  descriptionKey: 'description',
  notesStatsKey: 'cfa1_2024_notes_stats.answer_status',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Notes/View/ApiAttributesKays.js